import { Injectable, Inject } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '../../../node_modules/@angular/common/http';
import {Comment} from '../models/comment.model';
import { IQueryResult } from '../base/interfaces/IQueryResult';
import { Observable } from '../../../node_modules/rxjs';
import { HistoryBaseService } from './history-base.service';

@Injectable()
export class CommentService extends HistoryBaseService<Comment> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) { 
    super(http,rootUrl,'Comments','Comment');
  }
}
